export interface IStatistics extends Record<string, number> {
    // certificates
    ucqBoatmaster: number;
    government: number;
    sport: number;

    // qualifications
    ucqHelmsman: number;
    ucqAbleBoatman: number;
    ucqBoatman: number;
    ucqDeckhand: number;
    ucqApprentice: number;
    ucqMachineOperator: number;

    // specific authorizations
    cityStretchBasel: number;
    stretchWithRisksOberrhein: number;
    stretchWithRisksMittellrhein: number;
    radar: number;
    maritimeWaterways: number;
    largeConvoys: number;

    // security personnel
    adnBescheinigung: number;
    ucqLngExpert: number;
    ucqPassengerExpert: number;
}

export interface IStatisticsResult {
    issuedCertificates: IStatistics;
    firstIssueCertificates: IStatistics;
    suspendedCertificates: IStatistics;
    withdrawnCertificates: IStatistics;
    expiredCertificates: IStatistics;
}

export const statisticsInit: IStatistics = {
    ucqBoatmaster: 0,
    government: 0,
    sport: 0,
    ucqHelmsman: 0,
    ucqAbleBoatman: 0,
    ucqBoatman: 0,
    ucqDeckhand: 0,
    ucqApprentice: 0,
    ucqMachineOperator: 0,
    cityStretchBasel: 0,
    stretchWithRisksOberrhein: 0,
    stretchWithRisksMittellrhein: 0,
    radar: 0,
    maritimeWaterways: 0,
    largeConvoys: 0,
    adnBescheinigung: 0,
    ucqLngExpert: 0,
    ucqPassengerExpert: 0,
};
